import { Record } from "immutable";

const CustomerRecord = Record({
  id: null,
  customerKey: null,
  customerName: "",
  employees: 0,
  industryId: "",
  industryParentId: "",
  memo: "",
  logo: "",
  lockVersion: 0,
  // 関連
  latestSurvey: null,
  industry: "",
  industryParent: "",
  locales: [],
  selectedLocaleIds: [],
  isOpeningSurveyExist: false
});

class Customer extends CustomerRecord {
  isNew() {
    return this.id === null;
  }

  validation() {
    const errors = [];

    if (this.customerName === "") {
      errors.push("顧客名を入力してください。");
    }

    if (this.industryId === "") {
      errors.push("業種を選択してください。");
    }

    if (this.employees === "") {
      errors.push("従業員数を入力してください。");
    }

    if (this.selectedLocaleIds.length === 0) {
      errors.push("使用可能言語は一つ以上を選択してください。");
    }

    return errors;
  }

  isSelectedLang(id) {
    return this.selectedLocaleIds.indexOf(id) > -1;
  }
}

export const logoSize = { maxWidth: 300, maxHeight: 50 };

export default Customer;



// WEBPACK FOOTER //
// ./src/models/Customer.js